import { z } from 'zod';
import { Language } from '@/model/Translation.model';
import { dateSchema } from '@/model/utils';

export enum AiVoiceAccent {
  US = 'US',
  UK = 'UK',
}

export enum AiVoiceGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum UserLocation {
  TH = 'th',
  MY = 'my',
  TR = 'tr', // Turkey
  KR = 'kr', // Korea
  JP = 'jp', // Japan
  IN = 'in', // India
}

export class UserMetadata {
  public id: string;
  public userId: string;
  public language: Language;
  public location: string;
  public aiVoiceAccent: AiVoiceAccent;
  public aiVoiceGender: AiVoiceGender;
  public createdAt: Date;
  public updatedAt: Date;

  constructor(json: unknown) {
    const validJson = UserMetadata.zodSchema.parse(json);
    this.id = validJson.id;
    this.userId = validJson.userId;
    this.language = validJson.language;
    this.location = validJson.location;
    this.aiVoiceAccent = validJson.aiVoiceAccent;
    this.aiVoiceGender = validJson.aiVoiceGender;
    this.createdAt = validJson.createdAt;
    this.updatedAt = validJson.updatedAt;
  }

  public static zodSchema = z.object({
    id: z.string(),
    userId: z.string(),
    language: z.nativeEnum(Language),
    location: z.nativeEnum(UserLocation),
    aiVoiceAccent: z.nativeEnum(AiVoiceAccent),
    aiVoiceGender: z.nativeEnum(AiVoiceGender),
    createdAt: dateSchema,
    updatedAt: dateSchema,
  });

  public static fromJson(json: unknown) {
    return new UserMetadata(json);
  }

  public static fromJsonArray(jsonArray: unknown) {
    return z
      .array(UserMetadata.zodSchema)
      .parse(jsonArray)
      .map((validatedJson) => UserMetadata.fromJson(validatedJson));
  }
}
